// extracted by mini-css-extract-plugin
export var columnList = "_dy-0";